import { render, staticRenderFns } from "./OwnerInfo.vue?vue&type=template&id=20d8e0b1&scoped=true&"
import script from "./OwnerInfo.vue?vue&type=script&lang=js&"
export * from "./OwnerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d8e0b1",
  null
  
)

export default component.exports